import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Dairy Brand — New-customers campaign. Real lifetime aggregates from
// ANALYTICS.ADS.CAMPAIGN_PERIODS over the 31 complete months Feb 2024 – Aug 2026.
// Monthly series lives in realBrandData.ts.
//
// `monthlyBudgetDollars` is the shared pool, not a cap on this campaign. The
// advertiser is POOLED, so AD_CAMPAIGNS reports no per-campaign budget and both
// campaigns draw on the same $6,000 — which is why the reorder campaign carries
// the same figure rather than a slice of it. Nothing sums the two.
//
// `salesDollars` is uncapped lifetime booked sales and `bestEstimateSalesDollars`
// the first-year projection. Here the projection sits *below* booked sales ($399k
// against $456k), the opposite of a young program: most of these cohorts are
// years past their first twelve months, so they have outrun what the first year
// predicted.
//
// Nothing in ads-manager-2 reads `segmentMetrics`, so this lifetime figure is
// deliberately left uncapped and does not match the profile entity's
// cohort-basis $378,633.
export const campDbNew: FaireAdCampaignEntity = {
  token: "camp_db_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_dairy_brand",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 6000,
  startedRunningAt: "2024-02-10",
  segmentMetrics: {
    numCustomersAcquired: 663,
    salesDollars: 455724,
    totalAdsSpendDollars: 54215,
    cpaDollars: 82,
    bestEstimateSalesDollars: 398889,
    bestEstimateRoas: 7.36,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
